window.MESON_QUICK_ADD_FRAME_IMAGES = Object.assign(
  {
    canvas:
      'https://cdn.shopify.com/s/files/1/1013/0869/4893/files/1_a5631ba9-3903-4b8d-a870-292489041c37.png?v=1785405621',
    frameless:
      'https://cdn.shopify.com/s/files/1/1013/0869/4893/files/2.jpg?v=1785405621',
    gold:
      'https://cdn.shopify.com/s/files/1/1013/0869/4893/files/3.png?v=1785405621',
    silver:
      'https://cdn.shopify.com/s/files/1/1013/0869/4893/files/4.png?v=1785405621',
    black:
      'https://cdn.shopify.com/s/files/1/1013/0869/4893/files/5.jpg?v=1785405621',
    white:
      'https://cdn.shopify.com/s/files/1/1013/0869/4893/files/6.png?v=1785405621',
    wood:
      'https://cdn.shopify.com/s/files/1/1013/0869/4893/files/7.png?v=1785405621'
  },
  window.MESON_QUICK_ADD_FRAME_IMAGES || {}
);

const ensureMesonQuickAddGalleryStyles = () => {
  if (document.getElementById('MesonQuickAddGalleryLayout')) {
    return;
  }

  const style = document.createElement('style');
  style.id = 'MesonQuickAddGalleryLayout';
  style.textContent = `
    quick-add-modal .meson-quick-add-gallery {
      display: flex !important;
      width: 100% !important;
      height: auto !important;
      min-height: 0 !important;
      max-height: none !important;
      flex-direction: column !important;
      overflow: visible !important;
    }

    quick-add-modal .meson-quick-add-gallery > slider-component:not(.thumbnail-slider) {
      position: relative !important;
      display: block !important;
      width: 100% !important;
      height: auto !important;
      min-height: 0 !important;
      aspect-ratio: 1 / 1 !important;
      flex: 0 0 auto !important;
      overflow: hidden !important;
    }

    quick-add-modal .meson-quick-add-gallery .product__media-list {
      position: relative !important;
      display: block !important;
      width: 100% !important;
      height: 100% !important;
      min-height: 0 !important;
      margin: 0 !important;
      padding: 0 !important;
      overflow: hidden !important;
    }

    quick-add-modal .meson-quick-add-gallery .product__media-item {
      position: absolute !important;
      inset: 0 !important;
      display: none !important;
      width: 100% !important;
      max-width: none !important;
      height: 100% !important;
      margin: 0 !important;
      padding: 0 !important;
    }

    quick-add-modal .meson-quick-add-gallery .product__media-item.is-active {
      display: block !important;
    }

    quick-add-modal .meson-quick-add-gallery .product-media-container,
    quick-add-modal .meson-quick-add-gallery .product__media,
    quick-add-modal .meson-quick-add-gallery .product__modal-opener,
    quick-add-modal .meson-quick-add-gallery .product__media-toggle {
      position: relative !important;
      display: block !important;
      width: 100% !important;
      max-width: none !important;
      height: 100% !important;
      min-height: 0 !important;
      margin: 0 !important;
      padding: 0 !important;
      aspect-ratio: auto !important;
    }

    quick-add-modal .meson-quick-add-gallery .product__media img,
    quick-add-modal .meson-quick-add-gallery img.image-magnify-hover {
      position: absolute !important;
      inset: 0 !important;
      display: block !important;
      width: 100% !important;
      max-width: 100% !important;
      height: 100% !important;
      max-height: 100% !important;
      margin: 0 !important;
      object-fit: contain !important;
      object-position: center calc(50% + 12px) !important;
    }

    quick-add-modal .meson-quick-add-gallery .thumbnail-slider {
      position: relative !important;
      inset: auto !important;
      display: block !important;
      width: 100% !important;
      height: auto !important;
      min-height: 0 !important;
      margin: 14px 0 0 !important;
      padding: 0 8px !important;
      flex: 0 0 auto !important;
      overflow: visible !important;
      transform: none !important;
      background: transparent !important;
    }

    quick-add-modal .meson-quick-add-gallery .thumbnail-list {
      position: relative !important;
      display: flex !important;
      width: 100% !important;
      height: auto !important;
      margin: 0 !important;
      padding: 0 0 4px !important;
      align-items: center !important;
      gap: 10px !important;
      overflow-x: auto !important;
      overflow-y: hidden !important;
      flex-wrap: nowrap !important;
      scroll-snap-type: x proximity;
      scrollbar-width: thin;
    }

    quick-add-modal .meson-quick-add-gallery .thumbnail-list__item {
      width: 58px !important;
      min-width: 58px !important;
      max-width: 58px !important;
      height: 58px !important;
      margin: 0 !important;
      flex: 0 0 58px !important;
      scroll-snap-align: start;
    }

    quick-add-modal .meson-quick-add-gallery .thumbnail {
      position: relative !important;
      display: block !important;
      width: 100% !important;
      height: 100% !important;
      margin: 0 !important;
      padding: 0 !important;
    }

    quick-add-modal .meson-quick-add-gallery .thumbnail img {
      position: static !important;
      display: block !important;
      width: 100% !important;
      height: 100% !important;
      object-fit: cover !important;
    }

    quick-add-modal .meson-quick-add-gallery .slider-buttons {
      display: none !important;
    }

    @media screen and (max-width: 749px) {
      quick-add-modal .meson-quick-add-gallery .thumbnail-slider {
        margin-top: 10px !important;
        padding-inline: 4px !important;
      }

      quick-add-modal .meson-quick-add-gallery .thumbnail-list__item {
        width: 52px !important;
        min-width: 52px !important;
        max-width: 52px !important;
        height: 52px !important;
        flex-basis: 52px !important;
      }
    }
  `;

  document.head.append(style);
};


const applyMesonQuickAddGalleryLayout = (gallery) => {
  const setImportant = (element, property, value) => {
    element?.style.setProperty(property, value, 'important');
  };

  const viewer =
    gallery.querySelector('.meson-gallery-viewer') ||
    gallery.querySelector(':scope > slider-component:not(.thumbnail-slider)');
  const thumbnailSlider = gallery.querySelector(
    '.meson-thumbnail-slider, .thumbnail-slider'
  );

  setImportant(gallery, 'display', 'grid');
  setImportant(gallery, 'grid-template-columns', 'minmax(0, 1fr)');
  setImportant(gallery, 'grid-template-rows', 'minmax(0, 1fr) 64px');
  setImportant(gallery, 'grid-template-areas', '"viewer" "thumbnails"');
  setImportant(gallery, 'gap', '14px');
  setImportant(gallery, 'height', '100%');
  setImportant(gallery, 'min-height', '0');
  setImportant(gallery, 'overflow', 'hidden');

  setImportant(viewer, 'grid-area', 'viewer');
  setImportant(viewer, 'position', 'relative');
  setImportant(viewer, 'width', '100%');
  setImportant(viewer, 'height', '100%');
  setImportant(viewer, 'min-height', '0');
  setImportant(viewer, 'overflow', 'hidden');

  setImportant(thumbnailSlider, 'grid-area', 'thumbnails');
  setImportant(thumbnailSlider, 'position', 'relative');
  setImportant(thumbnailSlider, 'inset', 'auto');
  setImportant(thumbnailSlider, 'width', '100%');
  setImportant(thumbnailSlider, 'height', '64px');
  setImportant(thumbnailSlider, 'max-height', '64px');
  setImportant(thumbnailSlider, 'margin', '0');
  setImportant(thumbnailSlider, 'transform', 'none');
  setImportant(thumbnailSlider, 'overflow', 'hidden');

  gallery
    .querySelectorAll('.meson-gallery-viewer .product__media-list')
    .forEach((element) => {
      setImportant(element, 'position', 'relative');
      setImportant(element, 'width', '100%');
      setImportant(element, 'height', '100%');
      setImportant(element, 'min-height', '0');
      setImportant(element, 'overflow', 'hidden');
    });

  gallery
    .querySelectorAll('.meson-gallery-viewer .product__media-item')
    .forEach((element) => {
      setImportant(element, 'position', 'absolute');
      setImportant(element, 'inset', '0');
      setImportant(element, 'width', '100%');
      setImportant(element, 'height', '100%');
      setImportant(element, 'min-height', '0');
      setImportant(element, 'overflow', 'hidden');
    });

  gallery
    .querySelectorAll(
      '.meson-gallery-viewer .product-media-container, .meson-gallery-viewer .product__media, .meson-gallery-viewer .product__modal-opener, .meson-gallery-viewer .product__media-toggle'
    )
    .forEach((element) => {
      setImportant(element, 'position', 'relative');
      setImportant(element, 'width', '100%');
      setImportant(element, 'max-width', 'none');
      setImportant(element, 'height', '100%');
      setImportant(element, 'min-height', '0');
      setImportant(element, 'margin', '0');
      setImportant(element, 'padding', '0');
      setImportant(element, 'overflow', 'hidden');
    });

  gallery
    .querySelectorAll(
      '.meson-gallery-viewer .product__media img, .meson-gallery-viewer img.image-magnify-hover'
    )
    .forEach((image) => {
      setImportant(image, 'position', 'absolute');
      setImportant(image, 'inset', '0');
      setImportant(image, 'display', 'block');
      setImportant(image, 'width', '100%');
      setImportant(image, 'max-width', '100%');
      setImportant(image, 'height', '100%');
      setImportant(image, 'max-height', '100%');
      setImportant(image, 'margin', '0');
      setImportant(image, 'object-fit', 'contain');
      setImportant(image, 'object-position', 'center calc(50% + 12px)');
    });
};

if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
        this.productData = null;
        this.selectedOptions = [];
        this.modalHosts = [];
        this.originalParent = null;
        this.originalNextSibling = null;
        this.variantUIObserver = null;
        this.variantUISyncTimer = null;
        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      hide(preventFocus = false) {
        const cartNotification =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');

        if (cartNotification) {
          cartNotification.setActiveElement(this.openedBy);
        }

        this.modalContent.innerHTML = '';
        this.classList.remove('meson-quick-add-is-loading');
        this.productData = null;
        this.selectedOptions = [];
        this.variantUIObserver?.disconnect();
        this.variantUIObserver = null;
        window.clearTimeout(this.variantUISyncTimer);
        this.variantUISyncTimer = null;

        if (preventFocus) {
          this.openedBy = null;
        }

        super.hide();
        this.releaseModalHosts();
        this.restoreOriginalPosition();
      }

      show(opener) {
        this.mountInViewport();
        this.prepareModalHosts();
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        this.showLoadingState();
        super.show(opener);
        this.forceViewportPosition();

        const loadingSpinner = opener.querySelector('.loading__spinner');
        const productUrl = opener.getAttribute('data-product-url');
        const productDataPromise = this.fetchProductData(productUrl).catch(
          (error) => {
            console.error('Quick Add product data failed to load:', error);
            return null;
          }
        );

        loadingSpinner?.classList.remove('hidden');

        fetch(productUrl)
          .then((response) => {
            if (!response.ok) {
              throw new Error(`Quick Add request failed: ${response.status}`);
            }

            return response.text();
          })
          .then(async (responseText) => {
            const responseHTML = new DOMParser().parseFromString(
              responseText,
              'text/html'
            );
            const productElement = responseHTML.querySelector('product-info');

            if (!productElement) {
              throw new Error(
                'Quick Add could not find <product-info> in the response.'
              );
            }

            const embeddedVariantData =
              this.readEmbeddedVariantData(productElement);

            this.preprocessHTML(productElement);

            HTMLUpdateUtility.setInnerHTML(
              this.modalContent,
              productElement.outerHTML
            );

            this.classList.remove('meson-quick-add-is-loading');
            super.show(opener);
            this.forceViewportPosition();
            window.requestAnimationFrame(() => {
              this.forceViewportPosition();
            });
            this.initializeMediaGallery();
            const ajaxProductData = await productDataPromise;
            const productData = this.normalizeProductData(
              embeddedVariantData,
              ajaxProductData
            );
            this.initializeProductOptions(productData);
            this.installMesonCartHandler();
            this.ensureProductTitle(productData, productUrl);
            this.ensureDetailsLink(productElement, productUrl);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            if (window.ProductModel) {
              window.ProductModel.loadShopifyXR();
            }

            this.modalContent
              .querySelector('product-component')
              ?.dispatchViewEvent?.();
          })
          .catch((error) => {
            console.error('Quick Add modal failed to load:', error);

            this.modalContent.innerHTML = `
              <div class="meson-quick-add-error">
                <p>Unable to load this product.</p>
                <a href="${productUrl}" class="button">
                  View full product details
                </a>
              </div>
            `;
            this.classList.remove('meson-quick-add-is-loading');
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            loadingSpinner?.classList.add('hidden');
          });
      }

      installMesonCartHandler() {
        this.modalContent
          .querySelectorAll('form[action*="/cart/add"]')
          .forEach((form) => {
            if (form.dataset.mesonCartHandler === 'true') {
              return;
            }

            form.dataset.mesonCartHandler = 'true';
            form.addEventListener(
              'submit',
              (event) => this.handleMesonAddToCart(event),
              true
            );
          });
      }

      async handleMesonAddToCart(event) {
        event.preventDefault();
        event.stopImmediatePropagation();

        const form = event.currentTarget;
        const submitButton = form.querySelector(
          '[type="submit"][name="add"], .product-form__submit'
        );
        const spinner = submitButton?.querySelector('.loading__spinner');
        const errorWrapper = form.querySelector(
          '.product-form__error-message-wrapper'
        );
        const errorMessage = form.querySelector(
          '.product-form__error-message'
        );
        const routeRoot = window.Shopify?.routes?.root || '/';

        submitButton?.setAttribute('aria-disabled', 'true');
        submitButton?.classList.add('loading');
        spinner?.classList.remove('hidden');

        if (errorWrapper) {
          errorWrapper.hidden = true;
        }

        try {
          const response = await fetch(routeRoot + 'cart/add.js', {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(form)
          });
          const result = await response.json();

          if (!response.ok) {
            throw new Error(
              result.description ||
                result.message ||
                'Unable to add this item to cart.'
            );
          }

          document.dispatchEvent(
            new CustomEvent('cart:refresh', {
              bubbles: true,
              detail: { source: 'quick-add-modal' }
            })
          );

          this.hide(true);
          window.requestAnimationFrame(() => {
            this.openMesonCartDrawer();
          });
        } catch (error) {
          if (errorMessage) {
            errorMessage.textContent = error.message;
          }

          if (errorWrapper) {
            errorWrapper.hidden = false;
          }

          console.error('Quick Add cart submission failed:', error);
        } finally {
          submitButton?.removeAttribute('aria-disabled');
          submitButton?.classList.remove('loading');
          spinner?.classList.add('hidden');
        }
      }

      openMesonCartDrawer() {
        const triggers = Array.from(
          document.querySelectorAll('[data-header-open="cart"]')
        );
        const trigger =
          triggers.find((item) => {
            const style = window.getComputedStyle(item);

            return (
              !item.hidden &&
              style.display !== 'none' &&
              style.visibility !== 'hidden'
            );
          }) || triggers[0];

        trigger?.click();
      }

      showLoadingState() {
        this.classList.add('meson-quick-add-is-loading');
        this.modalContent.innerHTML = `
          <div
            class="meson-quick-add-loading"
            role="status"
            aria-live="polite"
            aria-label="Loading product"
          >
            <span
              class="meson-quick-add-loading__spinner"
              aria-hidden="true"
            ></span>
            <span class="meson-quick-add-loading__text">
              Loading...
            </span>
          </div>
        `;
      }

      mountInViewport() {
        if (this.parentElement === document.body) {
          return;
        }

        this.originalParent = this.parentNode;
        this.originalNextSibling = this.nextSibling;
        document.body.append(this);
      }

      restoreOriginalPosition() {
        if (!this.originalParent) {
          return;
        }

        if (this.originalParent.isConnected) {
          const nextSibling =
            this.originalNextSibling?.parentNode === this.originalParent
              ? this.originalNextSibling
              : null;

          this.originalParent.insertBefore(this, nextSibling);
        } else {
          this.remove();
        }

        this.originalParent = null;
        this.originalNextSibling = null;
      }

      forceViewportPosition() {
        const content = this.querySelector('.quick-add-modal__content');
        const closeButton = this.querySelector(
          '.quick-add-modal__toggle'
        );

        this.style.setProperty('position', 'fixed', 'important');
        this.style.setProperty('inset', '0', 'important');
        this.style.setProperty('width', '100vw', 'important');
        this.style.setProperty('height', '100dvh', 'important');
        this.style.setProperty('margin', '0', 'important');
        this.style.setProperty('padding', '24px', 'important');
        this.style.setProperty('display', 'flex', 'important');
        this.style.setProperty('align-items', 'center', 'important');
        this.style.setProperty('justify-content', 'center', 'important');
        this.style.setProperty('transform', 'none', 'important');

        if (!content) {
          return;
        }

        content.style.setProperty('position', 'relative', 'important');
        content.style.setProperty('inset', 'auto', 'important');
        content.style.setProperty('top', 'auto', 'important');
        content.style.setProperty('right', 'auto', 'important');
        content.style.setProperty('bottom', 'auto', 'important');
        content.style.setProperty('left', 'auto', 'important');
        content.style.setProperty('margin', '0', 'important');
        content.style.setProperty('transform', 'none', 'important');

        if (closeButton) {
          if (closeButton.parentElement !== content) {
            content.prepend(closeButton);
          }

          closeButton.style.setProperty(
            'position',
            'absolute',
            'important'
          );
          closeButton.style.setProperty('top', '18px', 'important');
          closeButton.style.setProperty('right', '18px', 'important');
          closeButton.style.setProperty('inset-inline-end', '18px', 'important');
          closeButton.style.setProperty('margin', '0', 'important');
          closeButton.style.setProperty('transform', 'none', 'important');
        }
      }

      prepareModalHosts() {
        this.releaseModalHosts();

        let ancestor = this.parentElement;

        while (ancestor && ancestor !== document.body) {
          const styles = window.getComputedStyle(ancestor);
          const createsContainingBlock =
            styles.transform !== 'none' ||
            styles.filter !== 'none' ||
            styles.perspective !== 'none' ||
            styles.willChange.includes('transform') ||
            styles.contain.includes('paint') ||
            styles.contain.includes('layout');

          if (createsContainingBlock) {
            ancestor.classList.add('meson-quick-add-modal-host');
            this.modalHosts.push(ancestor);
          }

          ancestor = ancestor.parentElement;
        }
      }

      releaseModalHosts() {
        this.modalHosts.forEach((host) => {
          host.classList.remove('meson-quick-add-modal-host');
        });
        this.modalHosts = [];
      }

      ensureProductTitle(productData, productUrl) {
        const infoContainer = this.modalContent.querySelector(
          'product-info .product__info-container'
        );

        if (!infoContainer || !productData?.title) {
          return;
        }

        let titleBlock = infoContainer.querySelector(
          '.product__title:not(a)'
        );

        if (!titleBlock) {
          titleBlock = document.createElement('div');
          titleBlock.className = 'product__title';

          const priceBlock = infoContainer.querySelector(
            '[id^="price-"], .price'
          );

          if (priceBlock) {
            priceBlock.before(titleBlock);
          } else {
            infoContainer.prepend(titleBlock);
          }
        }

        let titleLink = titleBlock.querySelector(':scope > a');

        if (!titleLink) {
          titleLink = document.createElement('a');
          const heading = document.createElement('h2');

          titleLink.href = productUrl;
          heading.textContent = productData.title;
          titleLink.append(heading);
          titleBlock.append(titleLink);
        }

        titleLink.classList.add('meson-quick-add-title-link');
      }

      ensureDetailsLink(productElement, productUrl) {
        const productInfo =
          this.modalContent.querySelector('product-info') ||
          productElement;
        const infoContainer = productInfo?.querySelector(
          '.product__info-container'
        );
        const existingLink = infoContainer?.querySelector(
          '.product__view-details, .meson-quick-add-details-link'
        );

        if (!infoContainer || existingLink) {
          existingLink?.classList.add('meson-quick-add-details-link');
          return;
        }

        const link = document.createElement('a');
        const label = document.createElement('span');
        const arrow = document.createElement('span');

        link.className = 'meson-quick-add-details-link';
        link.href = productUrl;
        label.textContent = 'View full details';
        arrow.textContent = '→';
        arrow.setAttribute('aria-hidden', 'true');
        link.append(label, arrow);
        infoContainer.append(link);
      }

      async fetchProductData(productUrl) {
        const jsonUrl = new URL(productUrl, window.location.origin);
        jsonUrl.pathname = `${jsonUrl.pathname.replace(/\/$/, '')}.js`;
        jsonUrl.search = '';

        const response = await fetch(jsonUrl.toString(), {
          headers: {
            Accept: 'application/json'
          }
        });

        if (!response.ok) {
          throw new Error(`Product JSON request failed: ${response.status}`);
        }

        return response.json();
      }

      readEmbeddedVariantData(productElement) {
        const script = productElement.querySelector(
          'script[id^="MesonVariantData-"], script[data-meson-variant-data]'
        );

        if (!script?.textContent.trim()) {
          return null;
        }

        try {
          const data = JSON.parse(script.textContent);
          return Array.isArray(data?.variants) && data.variants.length
            ? data
            : null;
        } catch (error) {
          console.error('Quick Add embedded variant data is invalid:', error);
          return null;
        }
      }

      normalizeProductData(embeddedData, ajaxData) {
        const source =
          Array.isArray(embeddedData?.variants) &&
          embeddedData.variants.length
            ? embeddedData
            : ajaxData;

        if (!Array.isArray(source?.variants) || !source.variants.length) {
          return ajaxData || embeddedData || null;
        }

        const ajaxVariants = new Map(
          (ajaxData?.variants || []).map((variant) => [
            String(variant.id),
            variant
          ])
        );
        const variants = source.variants.map((variant) => {
          const ajaxVariant = ajaxVariants.get(String(variant.id)) || {};
          const priceCents = Number(
            variant.priceCents ??
              (typeof variant.price === 'number'
                ? variant.price
                : ajaxVariant.price)
          );
          const compareAtPriceCents = Number(
            variant.compareAtPriceCents ??
              variant.compare_at_price ??
              ajaxVariant.compare_at_price ??
              0
          );

          return {
            ...ajaxVariant,
            ...variant,
            id: variant.id ?? ajaxVariant.id,
            available: Boolean(
              variant.available ?? ajaxVariant.available
            ),
            options:
              variant.options ||
              this.getVariantOptions(ajaxVariant),
            price: Number.isFinite(priceCents) ? priceCents : 0,
            compare_at_price: Number.isFinite(compareAtPriceCents)
              ? compareAtPriceCents
              : 0,
            mesonFormattedPrice:
              typeof variant.price === 'string'
                ? variant.price
                : '',
            mesonFormattedCompareAtPrice:
              typeof variant.compareAtPrice === 'string'
                ? variant.compareAtPrice
                : ''
          };
        });
        const optionNames =
          embeddedData?.optionNames ||
          source.optionNames ||
          ajaxData?.options ||
          [];
        const options = optionNames.map((option, optionIndex) => {
          const name =
            typeof option === 'string'
              ? option
              : option.name ||
                option.title ||
                `Option ${optionIndex + 1}`;
          const suppliedValues =
            typeof option === 'object' && Array.isArray(option.values)
              ? option.values
              : [];
          const variantValues = variants
            .map((variant) =>
              this.getVariantOptions(variant)[optionIndex]
            )
            .filter(Boolean);

          return {
            name,
            values: [...new Set([...suppliedValues, ...variantValues])]
          };
        });

        return {
          ...(ajaxData || {}),
          ...source,
          currency:
            source.currency ||
            ajaxData?.currency ||
            window.Shopify?.currency?.active ||
            'USD',
          options,
          variants
        };
      }

      initializeProductOptions(productData) {
        const productInfo = this.modalContent.querySelector('product-info');
        let appBlock = productInfo?.querySelector(
          '[data-product-options-app]'
        );

        if (!productInfo) {
          return;
        }

        if (!appBlock) {
          appBlock = document.createElement('div');
          appBlock.className = 'meson-app-block';
          appBlock.setAttribute('data-product-options-app', '');
          productInfo
            .querySelector('.product__info-container')
            ?.append(appBlock);
        }

        this.productData = productData;
        this.revealProductOptions(appBlock);
        this.buildFallbackProductOptions(
          productInfo,
          appBlock,
          productData
        );
        this.observeVariantUI(productInfo);
      }

      revealProductOptions(appBlock) {
        appBlock.hidden = false;
        appBlock.removeAttribute('aria-hidden');
        appBlock.classList.remove(
          'hidden',
          'visually-hidden',
          'small-hide',
          'medium-hide',
          'large-up-hide'
        );
        appBlock.classList.add('meson-quick-add-options');
        appBlock.style.removeProperty('display');
        appBlock.style.removeProperty('visibility');
        appBlock.style.removeProperty('opacity');
      }

      waitForProductOptions(productInfo, appBlock, productData) {
        let attempts = 0;
        const maximumAttempts = 15;

        const check = () => {
          attempts += 1;

          const renderedPicker = Array.from(
            appBlock.querySelectorAll(
              'select, ' +
                'input[type="radio"], ' +
                '.swatch, ' +
                '[data-option-index], ' +
                '[data-option-value], ' +
                '[data-value]'
            )
          ).find((element) => {
            if (element.getClientRects().length) {
              return true;
            }

            return Boolean(
              element
                .closest('label, .swatch, [data-option-index]')
                ?.getClientRects().length
            );
          });

          if (renderedPicker) {
            this.settleProductOptions(productInfo, appBlock);
            return;
          }

          if (attempts < maximumAttempts) {
            window.setTimeout(check, 100);
          } else {
            this.buildFallbackProductOptions(
              productInfo,
              appBlock,
              productData
            );
          }
        };

        check();
      }

      buildFallbackProductOptions(productInfo, appBlock, productData) {
        if (
          appBlock.querySelector('.meson-product-picker-fallback') ||
          !Array.isArray(productData?.variants) ||
          !productData.variants.length
        ) {
          this.arrangeQuickAddBlocks(productInfo, appBlock);
          return;
        }

        const definitions = this.normalizeOptionDefinitions(productData);

        if (!definitions.length) {
          this.arrangeQuickAddBlocks(productInfo, appBlock);
          return;
        }

        const variantInput = productInfo.querySelector(
          'form[action*="/cart/add"] input[name="id"], input.product-variant-id[name="id"]'
        );
        const initialVariant =
          productData.variants.find(
            (variant) => Number(variant.id) === Number(variantInput?.value)
          ) ||
          productData.variants.find((variant) => variant.available) ||
          productData.variants[0];

        this.selectedOptions = this.getVariantOptions(initialVariant);
        appBlock.innerHTML = '';

        const picker = document.createElement('div');
        picker.className = 'meson-product-picker-fallback';
        picker.setAttribute('aria-label', 'Product options');

        const sizeIndex = this.findSizeOptionIndex(definitions);
        const frameIndex = this.findFrameOptionIndex(
          definitions,
          sizeIndex
        );
        const order = [
          sizeIndex,
          frameIndex,
          ...definitions.map((_, index) => index)
        ].filter((index, position, indexes) => {
          return index >= 0 && indexes.indexOf(index) === position;
        });

        order.forEach((optionIndex) => {
          const definition = definitions[optionIndex];

          if (optionIndex === frameIndex) {
            picker.append(
              this.createFallbackFrameControl(
                definition,
                optionIndex,
                productInfo
              )
            );
          } else {
            picker.append(
              this.createFallbackSelectControl(
                definition,
                optionIndex,
                productInfo
              )
            );
          }
        });

        appBlock.append(picker);
        this.arrangeQuickAddBlocks(productInfo, appBlock);
        this.refreshFallbackPicker(productInfo);
      }

      normalizeOptionDefinitions(productData) {
        return (productData.options || []).map((option, index) => {
          const name =
            typeof option === 'string'
              ? option
              : option.name || option.title || `Option ${index + 1}`;
          const suppliedValues =
            typeof option === 'object' && Array.isArray(option.values)
              ? option.values
              : [];
          const variantValues = productData.variants
            .map((variant) => this.getVariantOptions(variant)[index])
            .filter(Boolean);

          return {
            name,
            values: [...new Set([...suppliedValues, ...variantValues])]
          };
        });
      }

      getVariantOptions(variant) {
        if (Array.isArray(variant?.options)) {
          return variant.options;
        }

        return [
          variant?.option1,
          variant?.option2,
          variant?.option3
        ].filter((value) => value !== null && value !== undefined);
      }

      findSizeOptionIndex(definitions) {
        const pattern =
          /size|dimensions?|format|height|width|尺寸|规格|大小/i;
        const index = definitions.findIndex((definition) =>
          pattern.test(definition.name)
        );

        return index >= 0 ? index : 0;
      }

      findFrameOptionIndex(definitions, sizeIndex) {
        const pattern =
          /frame|framing|canvas|stretch|finish|style|装裱|画框|边框|框型/i;
        const index = definitions.findIndex(
          (definition, optionIndex) =>
            optionIndex !== sizeIndex &&
            pattern.test(definition.name)
        );

        if (index >= 0) {
          return index;
        }

        return definitions.findIndex(
          (_, optionIndex) => optionIndex !== sizeIndex
        );
      }

      createFallbackSelectControl(
        definition,
        optionIndex,
        productInfo
      ) {
        const group = document.createElement('div');
        const label = document.createElement('label');
        const selectedValue = document.createElement('strong');
        const selectWrap = document.createElement('span');
        const select = document.createElement('select');
        const id = `MesonQuickOption-${this.id}-${optionIndex}`;

        group.className =
          'meson-product-picker-fallback__group meson-product-picker-fallback__group--select';
        label.className = 'meson-product-picker-fallback__label';
        label.htmlFor = id;
        label.append(`${definition.name}: `, selectedValue);
        selectedValue.className =
          'meson-product-picker-fallback__selected-value';
        selectedValue.textContent =
          this.selectedOptions[optionIndex] || '';
        selectWrap.className =
          'meson-product-picker-fallback__select-wrap';
        select.className = 'meson-product-picker-fallback__select';
        select.id = id;
        select.dataset.optionIndex = String(optionIndex);

        definition.values.forEach((value) => {
          const option = document.createElement('option');
          option.value = value;
          option.textContent = value;
          option.selected = this.selectedOptions[optionIndex] === value;
          select.append(option);
        });

        select.addEventListener('change', () => {
          this.selectedOptions[optionIndex] = select.value;
          this.resolveFallbackVariant(optionIndex);
          this.refreshFallbackPicker(productInfo);
        });

        selectWrap.append(select);
        group.append(label, selectWrap);

        return group;
      }

      createFallbackFrameControl(
        definition,
        optionIndex,
        productInfo
      ) {
        const fieldset = document.createElement('fieldset');
        const legend = document.createElement('legend');
        const selectedValue = document.createElement('strong');
        const options = document.createElement('div');

        fieldset.className =
          'meson-product-picker-fallback__group meson-product-picker-fallback__group--frame';
        fieldset.dataset.optionIndex = String(optionIndex);
        legend.className = 'meson-product-picker-fallback__label';
        legend.append(`${definition.name}: `, selectedValue);
        selectedValue.className =
          'meson-product-picker-fallback__selected-value';
        selectedValue.textContent =
          this.selectedOptions[optionIndex] || '';
        options.className = 'meson-product-picker-fallback__frames';

        definition.values.forEach((value, valueIndex) => {
          const button = document.createElement('button');
          const visual = document.createElement('span');
          const text = document.createElement('span');

          button.type = 'button';
          button.className =
            'meson-product-picker-fallback__frame-button';
          button.dataset.optionIndex = String(optionIndex);
          button.dataset.optionValue = value;
          button.setAttribute('role', 'radio');
          button.setAttribute('aria-label', value);
          button.title = value;
          visual.className =
            `meson-product-picker-fallback__frame-visual ` +
            this.getFrameVisualClass(value, valueIndex);
          const frameImageUrl = this.getFrameImageUrl(value, valueIndex);

          if (frameImageUrl) {
            const image = document.createElement('img');
            image.src = frameImageUrl;
            image.alt = '';
            image.loading = 'lazy';
            image.decoding = 'async';
            visual.classList.add(
              'meson-product-picker-fallback__frame-visual--custom-image'
            );
            visual.append(image);
          }

          text.className = 'visually-hidden';
          text.textContent = value;

          button.addEventListener('click', () => {
            if (button.disabled) {
              return;
            }

            this.selectedOptions[optionIndex] = value;
            this.resolveFallbackVariant(optionIndex);
            this.refreshFallbackPicker(productInfo);
          });

          button.append(visual, text);
          options.append(button);
        });

        fieldset.append(legend, options);

        return fieldset;
      }

      getFrameVisualClass(value, valueIndex) {
        const normalized = value.toLowerCase();
        const tones = [
          ['canvas', /rolled|roll|canvas only|卷|画布/],
          ['frameless', /frameless|unframed|stretched|无框/],
          ['gold', /gold|brass|金/],
          ['silver', /silver|aluminum|银/],
          ['black', /black|ebony|黑/],
          ['white', /white|ivory|白/],
          ['wood', /wood|oak|walnut|brown|木|棕/]
        ];
        const match = tones.find(([, pattern]) =>
          pattern.test(normalized)
        );
        const fallbacks = [
          'canvas',
          'frameless',
          'gold',
          'silver',
          'black',
          'white',
          'wood'
        ];
        const tone =
          match?.[0] ||
          fallbacks[valueIndex % fallbacks.length] ||
          'neutral';

        return `meson-product-picker-fallback__frame-visual--${tone}`;
      }

      getFrameImageUrl(value, valueIndex) {
        const visualClass = this.getFrameVisualClass(value, valueIndex);
        const key = visualClass.replace(
          'meson-product-picker-fallback__frame-visual--',
          ''
        );

        return window.MESON_QUICK_ADD_FRAME_IMAGES?.[key] || '';
      }

      resolveFallbackVariant(changedIndex) {
        if (this.findFallbackVariant()) {
          return;
        }

        const fallback = this.productData.variants.find((variant) => {
          const options = this.getVariantOptions(variant);

          return (
            variant.available &&
            options[changedIndex] ===
              this.selectedOptions[changedIndex]
          );
        });

        if (fallback) {
          this.selectedOptions = this.getVariantOptions(fallback);
        }
      }

      findFallbackVariant() {
        return this.productData?.variants.find((variant) => {
          const options = this.getVariantOptions(variant);

          return this.selectedOptions.every(
            (value, index) => options[index] === value
          );
        });
      }

      refreshFallbackPicker(productInfo) {
        const variant = this.findFallbackVariant();

        productInfo
          .querySelectorAll('.meson-product-picker-fallback__select')
          .forEach((select) => {
            const optionIndex = Number(select.dataset.optionIndex);
            select.value = this.selectedOptions[optionIndex];

            Array.from(select.options).forEach((option) => {
              option.disabled = !this.isFallbackOptionAvailable(
                optionIndex,
                option.value
              );
            });
          });

        productInfo
          .querySelectorAll(
            '.meson-product-picker-fallback__frame-button'
          )
          .forEach((button) => {
            const optionIndex = Number(button.dataset.optionIndex);
            const selected =
              this.selectedOptions[optionIndex] ===
              button.dataset.optionValue;

            button.classList.toggle('is-selected', selected);
            button.setAttribute('aria-checked', String(selected));
            button.disabled = !this.isFallbackOptionAvailable(
              optionIndex,
              button.dataset.optionValue
            );
          });

        productInfo
          .querySelectorAll(
            '.meson-product-picker-fallback__group'
          )
          .forEach((group) => {
            const control = group.querySelector(
              '[data-option-index]'
            );
            const optionIndex = Number(control?.dataset.optionIndex);
            const selectedValue = group.querySelector(
              '.meson-product-picker-fallback__selected-value'
            );

            if (selectedValue && Number.isFinite(optionIndex)) {
              selectedValue.textContent =
                this.selectedOptions[optionIndex] || '';
            }
          });

        this.updateFallbackVariantUI(productInfo, variant);
      }

      isFallbackOptionAvailable(optionIndex, value) {
        return this.productData.variants.some((variant) => {
          if (!variant.available) {
            return false;
          }

          const options = this.getVariantOptions(variant);

          return options[optionIndex] === value;
        });
      }

      getQuickAddQuantity(productInfo) {
        const input =
          productInfo.querySelector(
            '.meson-quick-add-quantity-block input[name="quantity"]'
          ) ||
          productInfo.querySelector(
            '.product-form__quantity input[name="quantity"]'
          );
        const minimum = Math.max(1, Number(input?.min || 1));
        const quantity = Number(input?.value || minimum);

        return Number.isFinite(quantity)
          ? Math.max(minimum, quantity)
          : minimum;
      }

      getVariantUnitPriceText(variant) {
        return (
          variant?.mesonFormattedPrice ||
          this.formatVariantMoney(Number(variant?.price || 0))
        );
      }

      getVariantComparePriceText(variant) {
        const compareAtPrice = Number(
          variant?.compare_at_price || 0
        );

        if (compareAtPrice <= Number(variant?.price || 0)) {
          return '';
        }

        return (
          variant?.mesonFormattedCompareAtPrice ||
          this.formatVariantMoney(compareAtPrice)
        );
      }

      setElementText(element, text) {
        if (element && element.textContent !== text) {
          element.textContent = text;
        }
      }

      updateFallbackVariantUI(
        productInfo,
        variant,
        {
          updateVariantInputs = true,
          updatePriceDisplay = true
        } = {}
      ) {
        if (updateVariantInputs) {
          productInfo
            .querySelectorAll(
              'form[action*="/cart/add"] input[name="id"], input.product-variant-id[name="id"]'
            )
            .forEach((input) => {
              if (!variant) {
                return;
              }

              const changed = String(input.value) !== String(variant.id);
              input.value = variant.id;
              input.disabled = false;

              if (changed) {
                input.dispatchEvent(
                  new Event('input', { bubbles: true })
                );
                input.dispatchEvent(
                  new Event('change', { bubbles: true })
                );
              }
            });
        }

        const available = Boolean(variant?.available);
        const quantity = this.getQuickAddQuantity(productInfo);
        const unitPriceText = variant
          ? this.getVariantUnitPriceText(variant)
          : '';
        const totalPriceText = variant
          ? quantity === 1
            ? unitPriceText
            : this.formatVariantMoney(
                Number(variant.price) * quantity
              )
          : '';
        const comparePriceText = variant
          ? this.getVariantComparePriceText(variant)
          : '';
        const onSale = Boolean(comparePriceText);

        productInfo
          .querySelectorAll(
            'form[action*="/cart/add"] button[name="add"], .product-form__submit'
          )
          .forEach((button) => {
            const label = button.querySelector(
              'span:not(.sold-out-message)'
            );
            const nextText = available
              ? `ADD TO CART – ${totalPriceText}`
              : 'SOLD OUT';

            button.disabled = !available;
            button.setAttribute('aria-disabled', String(!available));
            this.setElementText(label, nextText);
          });

        if (!variant) {
          return;
        }

        productInfo.dataset.mesonSelectedVariantId = String(variant.id);

        if (updatePriceDisplay) {
          productInfo
            .querySelectorAll(
              '[data-moomel-current-price], .moomel-current-price, .price__regular .price-item--regular, .price__sale .price-item--sale'
            )
            .forEach((element) => {
              this.setElementText(element, unitPriceText);
            });

          productInfo
            .querySelectorAll(
              '[data-moomel-compare-price], .moomel-compare-price, .price__sale .price-item--regular'
            )
            .forEach((element) => {
              this.setElementText(element, comparePriceText);
              element.hidden = !onSale;

              if (onSale) {
                element.style.removeProperty('display');
              } else {
                element.style.setProperty('display', 'none');
              }
            });

          productInfo
            .querySelectorAll('.price, .moomel-live-price-row')
            .forEach((element) => {
              element.classList.toggle('price--on-sale', onSale);
              element.dataset.variantId = String(variant.id);
            });
        }

        this.updateFallbackMedia(productInfo, variant);
      }

      observeVariantUI(productInfo) {
        this.variantUIObserver?.disconnect();
        this.variantUIObserver = null;
        window.clearTimeout(this.variantUISyncTimer);

        const synchronize = () => {
          window.clearTimeout(this.variantUISyncTimer);
          this.variantUISyncTimer = window.setTimeout(() => {
            if (!productInfo.isConnected) {
              return;
            }

            const variant =
              this.findFallbackVariant() ||
              this.readVariantFromProductForm(productInfo);

            if (variant) {
              this.selectedOptions = this.getVariantOptions(variant);
              this.updateFallbackVariantUI(productInfo, variant, {
                updateVariantInputs: false,
                updatePriceDisplay: true
              });
            }
          }, 20);
        };

        if (productInfo.dataset.mesonQuantityPriceBound !== 'true') {
          productInfo.dataset.mesonQuantityPriceBound = 'true';

          const updateQuantityPrice = (event) => {
            if (
              !event.target.closest(
                '.product-form__quantity, .meson-quick-add-quantity-block'
              )
            ) {
              return;
            }

            window.setTimeout(synchronize, 0);
          };

          productInfo.addEventListener('input', updateQuantityPrice);
          productInfo.addEventListener('change', updateQuantityPrice);
          productInfo.addEventListener('click', updateQuantityPrice);
        }

        synchronize();
      }

      readVariantFromProductForm(productInfo) {
        if (!Array.isArray(this.productData?.variants)) {
          return null;
        }

        const inputs = Array.from(
          productInfo.querySelectorAll(
            'form[action*="/cart/add"] input[name="id"], input.product-variant-id[name="id"]'
          )
        ).reverse();

        for (const input of inputs) {
          const variant = this.productData.variants.find(
            (item) => Number(item.id) === Number(input.value)
          );

          if (variant) {
            return variant;
          }
        }

        return null;
      }

      getVisibleProductPrice(productInfo) {
        const priceBlocks = Array.from(
          productInfo.querySelectorAll('.price')
        );
        const priceBlock =
          priceBlocks.find(
            (element) =>
              element.getClientRects().length &&
              element.querySelector('.price-item')
          ) ||
          priceBlocks.find((element) =>
            element.querySelector('.price-item')
          ) ||
          productInfo.querySelector('[id^="price-"]');

        if (!priceBlock) {
          return '';
        }

        const salePrice = priceBlock.querySelector(
          '.price__sale .price-item--sale'
        );
        const regularPrice = priceBlock.querySelector(
          '.price__regular .price-item--regular'
        );
        const priceElement =
          priceBlock.classList.contains('price--on-sale') && salePrice
            ? salePrice
            : regularPrice || salePrice;

        return priceElement?.textContent.replace(/\s+/g, ' ').trim() || '';
      }

      syncAddButtonPriceFromVisiblePrice(productInfo, variant = null) {
        const selectedVariant =
          variant ||
          this.findFallbackVariant() ||
          this.readVariantFromProductForm(productInfo);

        if (!selectedVariant) {
          return;
        }

        this.updateFallbackVariantUI(productInfo, selectedVariant, {
          updateVariantInputs: false,
          updatePriceDisplay: true
        });
      }

      formatVariantMoney(cents) {
        if (
          window.Shopify &&
          typeof window.Shopify.formatMoney === 'function'
        ) {
          return window.Shopify.formatMoney(
            cents,
            window.theme?.moneyFormat ||
              window.Shopify.money_format ||
              '${{amount}}'
          );
        }

        if (typeof window.formatMoney === 'function') {
          return window.formatMoney(cents);
        }

        const currency =
          window.Shopify?.currency?.active ||
          this.productData?.currency ||
          'USD';

        return new Intl.NumberFormat(
          document.documentElement.lang || 'en',
          {
            style: 'currency',
            currency
          }
        ).format(Number(cents) / 100);
      }

      updateFallbackMedia(productInfo, variant) {
        const mediaId =
          variant.featured_media?.id || variant.featured_image?.id;

        if (!mediaId) {
          return;
        }

        const thumbnail = Array.from(
          productInfo.querySelectorAll(
            '.thumbnail[data-target], [data-media-id], [data-target]'
          )
        ).find((element) => {
          return (
            element.dataset.mediaId === String(mediaId) ||
            element.dataset.target?.endsWith(`-${mediaId}`)
          );
        });

        thumbnail?.click();
      }

      settleProductOptions(productInfo, appBlock) {
        let settled = false;
        let settleTimer;
        let maximumTimer;

        const finish = () => {
          if (settled) {
            return;
          }

          settled = true;
          window.clearTimeout(settleTimer);
          window.clearTimeout(maximumTimer);
          observer.disconnect();
          this.revealProductOptions(appBlock);
          this.arrangeQuickAddBlocks(productInfo, appBlock);
          this.bindRenderedProductOptions(productInfo, appBlock);

          productInfo.dispatchEvent(
            new CustomEvent('moomel:quick-view:product-options-ready', {
              bubbles: true,
              detail: {
                productInfo,
                appBlock
              }
            })
          );
        };

        const scheduleFinish = () => {
          window.clearTimeout(settleTimer);
          settleTimer = window.setTimeout(finish, 300);
        };

        const observer = new MutationObserver(scheduleFinish);

        observer.observe(appBlock, {
          childList: true,
          subtree: true,
          attributes: true
        });

        scheduleFinish();
        maximumTimer = window.setTimeout(finish, 2000);
      }

      bindRenderedProductOptions(productInfo, appBlock) {
        if (
          appBlock.dataset.mesonVariantBridgeBound === 'true' ||
          !this.productData
        ) {
          return;
        }

        appBlock.dataset.mesonVariantBridgeBound = 'true';
        this.unlockAvailableRenderedOptions(appBlock);

        const synchronize = (event) => {
          const preferredValue = this.findKnownOptionValue(
            event?.target,
            appBlock
          );

          [60, 220, 600].forEach((delay) => {
            window.setTimeout(() => {
              this.unlockAvailableRenderedOptions(appBlock);
              this.synchronizeRenderedOptions(
                productInfo,
                appBlock,
                preferredValue
              );
            }, delay);
          });
        };

        appBlock.addEventListener('change', synchronize);
        appBlock.addEventListener('input', synchronize);
        appBlock.addEventListener('click', synchronize);
        this.synchronizeRenderedOptions(productInfo, appBlock);
        window.setTimeout(
          () => this.unlockAvailableRenderedOptions(appBlock),
          250
        );
        window.setTimeout(
          () => this.unlockAvailableRenderedOptions(appBlock),
          750
        );
      }

      unlockAvailableRenderedOptions(appBlock) {
        appBlock
          .querySelectorAll(
            'input[type="radio"], option, button, [disabled]'
          )
          .forEach((control) => {
            if ('disabled' in control) {
              control.disabled = false;
            }

            control.removeAttribute('disabled');
            control.removeAttribute('aria-disabled');
            control.style.removeProperty('pointer-events');
            control.style.removeProperty('opacity');
          });

        appBlock
          .querySelectorAll(
            '.disabled, .soldout, .sold-out, ' +
              '[aria-disabled="true"], [data-disabled="true"]'
          )
          .forEach((element) => {
            if ('disabled' in element) {
              element.disabled = false;
            }

            element.removeAttribute('disabled');
            element.removeAttribute('aria-disabled');
            element.removeAttribute('data-disabled');
            element.classList.remove(
              'disabled',
              'soldout',
              'sold-out'
            );
            element.style.removeProperty('pointer-events');
            element.style.removeProperty('opacity');
          });
      }

      findKnownOptionValue(element, appBlock) {
        if (!(element instanceof Element) || !this.productData) {
          return '';
        }

        const knownValues = [
          ...new Set(
            this.productData.variants.flatMap((variant) =>
              this.getVariantOptions(variant)
            )
          )
        ];
        let current = element;

        while (current && current !== appBlock.parentElement) {
          const associatedLabel =
            current.id && window.CSS?.escape
              ? appBlock.querySelector(
                  `label[for="${CSS.escape(current.id)}"]`
                )
              : null;
          const closestLabel = current.closest?.('label');
          const imageAltValues = Array.from(
            current.querySelectorAll?.('img[alt]') || []
          ).map((image) => image.alt);
          const candidates = [
            current.dataset?.optionValue,
            current.dataset?.value,
            current.dataset?.label,
            current.getAttribute?.('aria-label'),
            current.getAttribute?.('title'),
            current.value,
            current.textContent,
            associatedLabel?.textContent,
            closestLabel?.textContent,
            current.getAttribute?.('alt'),
            ...imageAltValues
          ].filter(Boolean);

          for (const candidate of candidates) {
            const matched = this.matchKnownOptionValue(
              candidate,
              knownValues
            );

            if (matched) {
              return matched;
            }
          }

          if (current === appBlock) {
            break;
          }

          current = current.parentElement;
        }

        return '';
      }

      normalizeOptionValue(value) {
        return String(value || '')
          .normalize('NFKD')
          .toLowerCase()
          .replace(/&quot;/g, '"')
          .replace(/[‘’`′]/g, "'")
          .replace(/[“”″]/g, '"')
          .replace(/[×]/g, 'x')
          .replace(/\s+/g, '')
          .replace(/[^a-z0-9]/g, '');
      }

      matchKnownOptionValue(candidate, values) {
        const normalizedCandidate =
          this.normalizeOptionValue(candidate);

        if (!normalizedCandidate) {
          return '';
        }

        return (
          values.find(
            (value) =>
              this.normalizeOptionValue(value) ===
              normalizedCandidate
          ) ||
          values
            .slice()
            .sort((first, second) => second.length - first.length)
            .find((value) => {
              const normalizedValue =
                this.normalizeOptionValue(value);

              return (
                normalizedValue.length >= 4 &&
                (normalizedCandidate.includes(normalizedValue) ||
                  normalizedValue.includes(normalizedCandidate))
              );
            }) ||
          ''
        );
      }

      synchronizeRenderedOptions(
        productInfo,
        appBlock,
        preferredValue = ''
      ) {
        const definitions = this.normalizeOptionDefinitions(
          this.productData
        );
        const currentVariant =
          this.findFallbackVariant() ||
          this.productData.variants.find((variant) => variant.available) ||
          this.productData.variants[0];
        const currentOptions = this.getVariantOptions(currentVariant);
        const candidates = [];

        appBlock.querySelectorAll('select').forEach((select) => {
          if (select.value) {
            candidates.push(select.value);
          }
        });

        appBlock
          .querySelectorAll('input[type="radio"]:checked')
          .forEach((input) => {
            const value =
              this.findKnownOptionValue(input, appBlock) ||
              input.value;

            if (value) {
              candidates.push(value);
            }
          });

        appBlock
          .querySelectorAll(
            '[aria-checked="true"], ' +
              '.selected[data-value], ' +
              '.active[data-value], ' +
              '.is-selected[data-value]'
          )
          .forEach((element) => {
            const value =
              this.findKnownOptionValue(element, appBlock) ||
              element.dataset.value ||
              element.dataset.optionValue;

            if (value) {
              candidates.push(value);
            }
          });

        const uniqueCandidates = [...new Set(candidates)];
        const visibleLines = String(appBlock.innerText || '')
          .split(/\n+/)
          .map((line) => line.trim())
          .filter(Boolean);

        this.selectedOptions = definitions.map(
          (definition, optionIndex) => {
            const preferred = this.matchKnownOptionValue(
              preferredValue,
              definition.values
            );
            const selectedControlValue = uniqueCandidates
              .slice()
              .reverse()
              .map((candidate) =>
                this.matchKnownOptionValue(
                  candidate,
                  definition.values
                )
              )
              .find(Boolean);
            const normalizedName = this.normalizeOptionValue(
              definition.name
            );
            const matchingVisibleLine =
              visibleLines.find((line) =>
                this.normalizeOptionValue(line).includes(
                  normalizedName
                )
              ) || '';
            const visibleLineValue =
              this.matchKnownOptionValue(
                matchingVisibleLine,
                definition.values
              );

            return (
              preferred ||
              selectedControlValue ||
              visibleLineValue ||
              currentOptions[optionIndex] ||
              definition.values[0]
            );
          }
        );

        let variant = this.findFallbackVariant();

        if (!variant) {
          variant = this.productData.variants.find((item) => {
            const options = this.getVariantOptions(item);

            return this.selectedOptions.every(
              (value, index) => options[index] === value
            );
          });
        }

        this.updateFallbackVariantUI(productInfo, variant, {
          updateVariantInputs: true,
          updatePriceDisplay: true
        });
        this.syncAddButtonPriceFromVisiblePrice(productInfo, variant);
      }

      arrangeQuickAddBlocks(productInfo, appBlock) {
        const infoContainer = productInfo.querySelector(
          '.product__info-container'
        );

        if (!infoContainer) {
          return;
        }

        const quantity = productInfo.querySelector(
          '.product-form__quantity'
        );
        const buyButtons =
          productInfo.querySelector('.meson-buy-buttons') ||
          productInfo.querySelector('product-form') ||
          productInfo.querySelector('.product-form');
        const buttonGroup = buyButtons?.querySelector(
          '.product-form__buttons'
        );
        const optionsBlock = this.getDirectInfoBlock(
          appBlock,
          infoContainer
        );
        const buyBlock = this.getDirectInfoBlock(
          buyButtons,
          infoContainer
        );

        if (
          optionsBlock &&
          buyBlock &&
          optionsBlock !== buyBlock &&
          buyBlock.parentElement === infoContainer
        ) {
          buyBlock.before(optionsBlock);
        }

        optionsBlock?.classList.add('meson-quick-add-options-block');
        buyBlock?.classList.add('meson-quick-add-buy-block');

        if (!quantity || !buttonGroup) {
          return;
        }

        let quantityBlock = this.getDirectInfoBlock(
          quantity,
          infoContainer
        );

        if (buyBlock?.contains(quantity)) {
          quantityBlock = quantity;
        }

        if (
          quantityBlock &&
          quantityBlock !== buyBlock &&
          !buttonGroup.contains(quantityBlock)
        ) {
          buttonGroup.prepend(quantityBlock);
        }

        quantityBlock?.classList.add('meson-quick-add-quantity-block');
        if (
          quantityBlock &&
          quantityBlock.parentElement === buttonGroup &&
          buttonGroup.firstElementChild !== quantityBlock
        ) {
          buttonGroup.insertBefore(
            quantityBlock,
            buttonGroup.firstElementChild
          );
        }
        buttonGroup.classList.add('meson-quick-add-purchase-grid');
        productInfo.classList.add('meson-quick-add-ready');
      }

      getDirectInfoBlock(element, infoContainer) {
        if (!element || !infoContainer.contains(element)) {
          return null;
        }

        let block = element;

        while (
          block.parentElement &&
          block.parentElement !== infoContainer
        ) {
          block = block.parentElement;
        }

        return block.parentElement === infoContainer ? block : element;
      }

      initializeMediaGallery() {
        const gallery = this.modalContent.querySelector('media-gallery');

        if (!gallery || gallery.dataset.mesonGalleryReady === 'true') {
          return;
        }

        ensureMesonQuickAddGalleryStyles();
        gallery.classList.add('meson-quick-add-gallery');
        applyMesonQuickAddGalleryLayout(gallery);

        const mediaItems = Array.from(
          gallery.querySelectorAll('.product__media-item')
        );
        const thumbnails = Array.from(
          gallery.querySelectorAll(
            '.thumbnail-list .thumbnail, .thumbnail-slider .thumbnail'
          )
        );

        if (!mediaItems.length || !thumbnails.length) {
          return;
        }

        gallery.dataset.mesonGalleryReady = 'true';

        const alignThumbnailsToMedia = (activeItem) => {
          const viewer =
            gallery.querySelector('.meson-gallery-viewer') ||
            gallery.querySelector(
              ':scope > slider-component:not(.thumbnail-slider)'
            );
          const thumbnailSlider = gallery.querySelector(
            '.meson-thumbnail-slider, .thumbnail-slider'
          );
          const image = activeItem?.querySelector(
            '.product__media img, img.image-magnify-hover'
          );

          if (!viewer || !thumbnailSlider || !image) {
            return;
          }

          const updateAlignment = () => {
            if (!activeItem.classList.contains('is-active')) {
              return;
            }

            const viewerWidth = viewer.clientWidth;
            const viewerHeight = viewer.clientHeight;
            const naturalWidth = image.naturalWidth;
            const naturalHeight = image.naturalHeight;

            if (
              !viewerWidth ||
              !viewerHeight ||
              !naturalWidth ||
              !naturalHeight
            ) {
              return;
            }

            const scale = Math.min(
              viewerWidth / naturalWidth,
              viewerHeight / naturalHeight
            );
            const renderedWidth = Math.max(
              58,
              Math.min(viewerWidth, Math.round(naturalWidth * scale))
            );

            thumbnailSlider.style.setProperty(
              'width',
              String(renderedWidth) + 'px',
              'important'
            );
            thumbnailSlider.style.setProperty(
              'max-width',
              '100%',
              'important'
            );
            thumbnailSlider.style.setProperty(
              'margin',
              '0 auto',
              'important'
            );
          };

          if (image.complete && image.naturalWidth) {
            requestAnimationFrame(updateAlignment);
          } else {
            image.addEventListener('load', updateAlignment, { once: true });
          }
        };

        const galleryViewer =
          gallery.querySelector('.meson-gallery-viewer') ||
          gallery.querySelector(
            ':scope > slider-component:not(.thumbnail-slider)'
          );

        if (galleryViewer && 'ResizeObserver' in window) {
          gallery.mesonThumbnailResizeObserver?.disconnect();
          gallery.mesonThumbnailResizeObserver = new ResizeObserver(() => {
            alignThumbnailsToMedia(
              mediaItems.find((item) => item.classList.contains('is-active'))
            );
          });
          gallery.mesonThumbnailResizeObserver.observe(galleryViewer);
        }

        const findMediaItem = (thumbnail, thumbnailIndex) => {
          const target =
            thumbnail.dataset.target ||
            thumbnail.getAttribute('data-media-id') ||
            '';
          const targetId = target.replace(/^#/, '');
          const mediaId =
            thumbnail.dataset.mediaId ||
            targetId.split('-').filter(Boolean).pop() ||
            '';

          return (
            mediaItems.find((item) => {
              const itemId = item.id || '';
              const itemMediaId =
                item.dataset.mediaId ||
                item.querySelector('[data-media-id]')?.dataset.mediaId ||
                '';

              return (
                itemId === targetId ||
                itemId === `Slide-${targetId}` ||
                (targetId && itemId.endsWith(targetId)) ||
                (mediaId && itemId.endsWith(`-${mediaId}`)) ||
                (mediaId && String(itemMediaId) === String(mediaId))
              );
            }) || mediaItems[thumbnailIndex]
          );
        };

        const activateMedia = (activeItem, activeThumbnail) => {
          if (!activeItem) {
            return;
          }

          mediaItems.forEach((item) => {
            const active = item === activeItem;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-hidden', String(!active));
          });

          thumbnails.forEach((thumbnail) => {
            const active = thumbnail === activeThumbnail;
            thumbnail.classList.toggle('is-active', active);

            if (active) {
              thumbnail.setAttribute('aria-current', 'true');
            } else {
              thumbnail.removeAttribute('aria-current');
            }
          });

          alignThumbnailsToMedia(activeItem);
        };

        const initialThumbnail =
          thumbnails.find(
            (thumbnail) =>
              thumbnail.getAttribute('aria-current') === 'true' ||
              thumbnail.classList.contains('is-active')
          ) || thumbnails[0];
        const initialIndex = thumbnails.indexOf(initialThumbnail);

        activateMedia(
          findMediaItem(initialThumbnail, initialIndex),
          initialThumbnail
        );

        gallery.addEventListener(
          'click',
          (event) => {
            const thumbnail = event.target.closest('.thumbnail');

            if (!thumbnail || !gallery.contains(thumbnail)) {
              return;
            }

            const thumbnailIndex = thumbnails.indexOf(thumbnail);

            if (thumbnailIndex < 0) {
              return;
            }

            event.preventDefault();
            activateMedia(
              findMediaItem(thumbnail, thumbnailIndex),
              thumbnail
            );
          },
          true
        );
      }

      preprocessHTML(productElement) {
        productElement.classList.add('moomel-quick-add-product');

        productElement.querySelectorAll('script').forEach((script) => {
          if (
            script.textContent.includes('mesonPurchaseRowReady')
          ) {
            script.remove();
          }
        });

        productElement.classList.forEach((classApplied) => {
          if (
            classApplied.startsWith('color-') ||
            classApplied === 'gradient'
          ) {
            this.modalContent.classList.add(classApplied);
          }
        });

        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeQuickViewOnlyBlocks(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        productElement.querySelector('pickup-availability')?.remove();
        productElement.querySelector('product-modal')?.remove();

        productElement
          .querySelectorAll('modal-dialog')
          .forEach((modal) => modal.remove());
      }

      removeQuickViewOnlyBlocks(productElement) {
        productElement
          .querySelectorAll(
            '.meson-delivery-process, ' +
              '.meson-trust-list, ' +
              '[id^="MesonTrustDialog-"], ' +
              '.meson-sticky-cart'
          )
          .forEach((element) => element.remove());
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;

        if (!sectionId) {
          return;
        }

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;

        productElement.innerHTML =
          productElement.innerHTML.replaceAll(oldId, newId);

        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(
              attribute.name,
              attribute.value.replaceAll(oldId, newId)
            );
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector(
          '[id^="Slider-Gallery"]'
        );

        if (!galleryList) {
          return;
        }

        galleryList.setAttribute('role', 'presentation');

        galleryList
          .querySelectorAll('[id^="Slide-"]')
          .forEach((item) => item.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const mediaImages = product?.querySelectorAll(
          '.product__media img'
        );

        if (!mediaImages?.length) {
          return;
        }

        const mediaImageSizes =
          '(min-width: 1200px) 660px, ' +
          '(min-width: 990px) 52vw, ' +
          '(min-width: 750px) calc((100vw - 8rem) / 2), ' +
          'calc(100vw - 4rem)';

        mediaImages.forEach((image) => {
          image.setAttribute('sizes', mediaImageSizes);
        });
      }
    }
  );
}
/* MESON price hard-fix — keep this outside the customElements guard. */
(() => {
  if (window.__MESON_QUICK_ADD_PRICE_HARD_FIX__) return;
  window.__MESON_QUICK_ADD_PRICE_HARD_FIX__ = '2026-07-31-4';
  document.documentElement.dataset.mesonPriceHardFix = 'loaded';

  const cache = new Map();
  const timers = new WeakMap();
  const clean = (value) => String(value ?? '').replace(/\s+/g, ' ').trim();
  const variantOptions = (variant) =>
    (Array.isArray(variant?.options)
      ? variant.options
      : [variant?.option1, variant?.option2, variant?.option3]
    ).filter((value) => value !== null && value !== undefined).map(clean);

  const normalize = (data) => {
    if (!Array.isArray(data?.variants) || !data.variants.length) return null;
    const optionNames = (data.optionNames || data.options || []).map(
      (option, index) =>
        typeof option === 'string'
          ? option
          : option?.name || option?.title || 'Option ' + (index + 1)
    );

    return {
      ...data,
      optionNames,
      variants: data.variants.map((variant) => {
        const numericPrice = typeof variant.price === 'number' ? variant.price : NaN;
        const numericCompare =
          typeof variant.compare_at_price === 'number'
            ? variant.compare_at_price
            : NaN;
        const priceCents = Number(
          variant.priceCents ??
            variant.price_cents ??
            (Number.isFinite(numericPrice) ? numericPrice : 0)
        );
        const compareAtPriceCents = Number(
          variant.compareAtPriceCents ??
            variant.compare_at_price_cents ??
            (Number.isFinite(numericCompare) ? numericCompare : 0)
        );

        return {
          ...variant,
          id: String(variant.id),
          available: variant.available !== false,
          options: variantOptions(variant),
          priceCents: Number.isFinite(priceCents) ? priceCents : 0,
          compareAtPriceCents: Number.isFinite(compareAtPriceCents)
            ? compareAtPriceCents
            : 0,
          formattedPrice:
            variant.mesonFormattedPrice ||
            (typeof variant.price === 'string' ? variant.price : ''),
          formattedCompareAtPrice:
            variant.mesonFormattedCompareAtPrice ||
            (typeof variant.compareAtPrice === 'string'
              ? variant.compareAtPrice
              : '')
        };
      })
    };
  };

  const embeddedData = (modal) => {
    const scripts = modal.querySelectorAll(
      'script[type="application/json"], script[id*="MesonVariantData"]'
    );

    for (const script of scripts) {
      const text = script.textContent.trim();
      if (!text || !text.includes('"variants"')) continue;

      try {
        const data = normalize(JSON.parse(text));
        if (data) return data;
      } catch (error) {
        // Ignore unrelated JSON blocks.
      }
    }

    return null;
  };

  const productUrl = (modal) => {
    const openerUrl = modal.openedBy?.getAttribute?.('data-product-url');
    if (openerUrl) return new URL(openerUrl, location.origin).toString();

    const link = modal.querySelector(
      '[data-product-url], a[href*="/products/"]'
    );
    const value =
      link?.getAttribute('data-product-url') || link?.getAttribute('href');
    return value ? new URL(value, location.origin).toString() : '';
  };

  const remoteData = async (modal) => {
    const url = productUrl(modal);
    if (!url) return null;

    const jsonUrl = new URL(url);
    jsonUrl.pathname = jsonUrl.pathname.replace(/\/$/, '') + '.js';
    jsonUrl.search = '';
    const key = jsonUrl.toString();

    if (!cache.has(key)) {
      cache.set(
        key,
        fetch(key, { headers: { Accept: 'application/json' } })
          .then((response) => {
            if (!response.ok) throw new Error('HTTP ' + response.status);
            return response.json();
          })
          .then(normalize)
          .catch((error) => {
            console.error('MESON price hard-fix request failed:', error);
            cache.delete(key);
            return null;
          })
      );
    }

    return cache.get(key);
  };

  const productData = async (modal) =>
    normalize(modal.productData) || embeddedData(modal) || remoteData(modal);

  const optionIndex = (control, fallback = -1) => {
    const direct = Number(
      control?.dataset?.optionIndex ?? control?.dataset?.optionPosition
    );
    if (Number.isFinite(direct)) return direct;

    const name = control?.getAttribute?.('name') || '';
    const match = name.match(/(?:option|globo-option-)(\d+)$/i);
    return match ? Number(match[1]) : fallback;
  };

  const selectedOptions = (modal, data, trigger) => {
    const count = data.optionNames.length || data.variants[0]?.options.length || 0;
    const currentId = Array.from(modal.querySelectorAll('input[name="id"]'))
      .map((input) => input.value)
      .find(Boolean);
    const currentVariant = data.variants.find(
      (variant) => String(variant.id) === String(currentId)
    );
    const selected = Array.from({ length: count }, (_, index) =>
      clean(modal.selectedOptions?.[index]) || currentVariant?.options[index] || ''
    );

    modal
      .querySelectorAll('.meson-product-picker-fallback__select[data-option-index]')
      .forEach((select) => {
        const index = optionIndex(select);
        if (index >= 0 && select.value) selected[index] = clean(select.value);
      });

    modal
      .querySelectorAll(
        '.meson-product-picker-fallback__frame-button.is-selected, ' +
          '.meson-product-picker-fallback__frame-button[aria-checked="true"]'
      )
      .forEach((button) => {
        const index = optionIndex(button);
        if (index >= 0 && button.dataset.optionValue) {
          selected[index] = clean(button.dataset.optionValue);
        }
      });

    const app = modal.querySelector('[data-product-options-app]');
    app?.querySelectorAll('input[type="radio"]:checked').forEach((input, position) => {
      const index = optionIndex(input, position);
      if (index >= 0 && input.value) selected[index] = clean(input.value);
    });
    app?.querySelectorAll('select').forEach((select, position) => {
      const index = optionIndex(select, position);
      if (index >= 0 && select.value) selected[index] = clean(select.value);
    });

    const frame = trigger?.closest?.(
      '.meson-product-picker-fallback__frame-button'
    );
    if (frame) {
      const index = optionIndex(frame);
      if (index >= 0 && frame.dataset.optionValue) {
        selected[index] = clean(frame.dataset.optionValue);
      }
    }

    if (trigger?.matches?.('select')) {
      const index = optionIndex(trigger);
      if (index >= 0 && trigger.value) selected[index] = clean(trigger.value);
    }

    return selected;
  };

  const findVariant = (data, selected) =>
    data.variants.find((variant) =>
      selected.every(
        (value, index) => !value || clean(variant.options[index]) === clean(value)
      )
    );

  const money = (cents, data) => {
    if (window.Shopify?.formatMoney) {
      return window.Shopify.formatMoney(
        cents,
        window.theme?.moneyFormat || window.Shopify.money_format || '$' + '{{amount}}'
      );
    }

    return new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency',
      currency: data.currency || window.Shopify?.currency?.active || 'USD'
    }).format(Number(cents) / 100);
  };

  const text = (element, value) => {
    if (element && element.textContent !== value) element.textContent = value;
  };

  const apply = (modal, data, variant, selected) => {
    const productInfo = modal.querySelector('product-info') || modal;
    const quantityInput = productInfo.querySelector(
      '.meson-quick-add-quantity-block input[name="quantity"], ' +
        '.product-form__quantity input[name="quantity"]'
    );
    const quantity = Math.max(1, Number(quantityInput?.value || 1));
    const unitPrice = variant.formattedPrice || money(variant.priceCents, data);
    const totalPrice =
      quantity === 1 ? unitPrice : money(variant.priceCents * quantity, data);
    const onSale = variant.compareAtPriceCents > variant.priceCents;
    const comparePrice = onSale
      ? variant.formattedCompareAtPrice || money(variant.compareAtPriceCents, data)
      : '';
    const compareTotalPrice = onSale
      ? quantity === 1
        ? comparePrice
        : money(variant.compareAtPriceCents * quantity, data)
      : '';

    modal.__mesonPriceHardFixApplying = true;
    modal.selectedOptions = selected.slice();

    productInfo
      .querySelectorAll(
        'form[action*="/cart/add"] input[name="id"], ' +
          'input.product-variant-id[name="id"]'
      )
      .forEach((input) => {
        const changed = String(input.value) !== String(variant.id);
        input.value = variant.id;
        input.disabled = false;
        if (changed) {
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });

    productInfo
      .querySelectorAll(
        '[data-moomel-current-price], .moomel-current-price, ' +
          '.price__regular .price-item--regular, .price__sale .price-item--sale'
      )
      .forEach((element) => text(element, totalPrice));

    productInfo
      .querySelectorAll(
        '[data-moomel-compare-price], .moomel-compare-price, ' +
          '.price__sale .price-item--regular'
      )
      .forEach((element) => {
        text(element, compareTotalPrice);
        element.hidden = !onSale;
        if (onSale) element.style.removeProperty('display');
        else element.style.setProperty('display', 'none');
      });

    productInfo
      .querySelectorAll(
        'form[action*="/cart/add"] button[name="add"], .product-form__submit'
      )
      .forEach((button) => {
        const available = variant.available !== false;
        const label = button.querySelector('span:not(.sold-out-message)');
        button.disabled = !available;
        button.setAttribute('aria-disabled', String(!available));
        text(label, available ? 'ADD TO CART – ' + totalPrice : 'SOLD OUT');
      });

    if (onSale) {
      const discount = Math.round(
        (1 - variant.priceCents / variant.compareAtPriceCents) * 100
      );
      productInfo
        .querySelectorAll(
          '[data-moomel-discount], .moomel-discount-badge, .moomel-save-badge'
        )
        .forEach((element) => text(element, 'Save ' + discount + '%'));
    }

    productInfo.dataset.mesonSelectedVariantId = String(variant.id);
    productInfo.dataset.mesonPriceHardFix = 'applied';
    document.documentElement.dataset.mesonPriceHardFix = 'applied';
    modal.__mesonPriceHardFixApplying = false;
  };

  const sync = async (modal, trigger = null) => {
    if (!modal?.isConnected || modal.__mesonPriceHardFixApplying) return;
    const data = await productData(modal);
    if (!data) return;

    const selected = selectedOptions(modal, data, trigger);
    const variant = findVariant(data, selected);
    if (!variant) {
      console.warn('MESON price hard-fix could not match:', selected);
      return;
    }

    apply(modal, data, variant, selected);
  };

  const schedule = (modal, trigger = null) => {
    if (!modal) return;
    (timers.get(modal) || []).forEach((timer) => clearTimeout(timer));
    const next = [0, 60, 220, 650, 1200].map((delay) =>
      setTimeout(() => sync(modal, trigger), delay)
    );
    timers.set(modal, next);
  };

  const modalFor = (target) => target?.closest?.('quick-add-modal');
  const controls =
    '.meson-product-picker-fallback__select, ' +
    '.meson-product-picker-fallback__frame-button, ' +
    '[data-product-options-app] select, ' +
    '[data-product-options-app] input[type="radio"]';

  document.addEventListener('change', (event) => {
    if (event.target.matches?.(controls)) {
      schedule(modalFor(event.target), event.target);
    }
  }, true);

  document.addEventListener('input', (event) => {
    if (event.target.matches?.(controls + ', input[name="quantity"]')) {
      schedule(modalFor(event.target), event.target);
    }
  }, true);

  document.addEventListener('click', (event) => {
    const target = event.target.closest?.(
      controls + ', quantity-input button, .quantity__button'
    );
    if (target) schedule(modalFor(target), target);
  }, true);

  const observer = new MutationObserver((mutations) => {
    const modals = new Set();
    mutations.forEach((mutation) => {
      const owner = mutation.target.closest?.('quick-add-modal');
      if (owner) modals.add(owner);

      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;
        if (node.matches('quick-add-modal')) modals.add(node);
        node.querySelectorAll?.('quick-add-modal').forEach((modal) => modals.add(modal));
      });
    });
    modals.forEach((modal) => schedule(modal));
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['open', 'value']
  });

  document.querySelectorAll('quick-add-modal[open]').forEach((modal) => schedule(modal));
})();
